import { required } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    rota_id: { required },
    regex_id: { required },
  },
}

export const validateComputed = {
  rotaIdErrors() {
    const errors = []
    if (!this.$v.form.rota_id.$dirty) return errors
    !this.$v.form.rota_id.required && errors.push('Rota é obritagória.')
    return errors
  },
  regexIdErrors() {
    const errors = []
    if (!this.$v.form.regex_id.$dirty) return errors
    !this.$v.form.regex_id.required && errors.push('Regex é obritagória.')
    return errors
  },
}
